import {
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useModalContext,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalHeaderWithBackButton } from '$/components/common/Modals/ModalHeaderWithBackButton';
import { StyledScrollWrapper } from '$/components/common/StyledScrollWrapper';
import { RegisterSchoolForm } from '$/components/core/Authentication/components/RegisterSchoolForm';
import { trackContentImpression, trackContentInteraction } from '$/logger';

export const RegisterSchoolModalContent = () => {
  const { t } = useTranslation();
  const { onClose } = useModalContext();

  useEffect(() => {
    trackContentImpression('SchoolAccount', 'Registration', 'Open');
  }, []);

  return (
    <ModalContent
      overflow='hidden'
      maxW='700px'
      maxH='95%'
      bg='background'
      borderRadius='12px'
    >
      <ModalHeaderWithBackButton
        headerText={t('school.registerSchool.modalHeader')}
      />
      <ModalCloseButton
        top='0'
        right='0'
        mt='8'
        mr='8'
        onClick={() => {
          trackContentInteraction(
            'ClickButton',
            'SchoolAccount',
            'Registration',
            'Cancel',
          );
          onClose();
        }}
      />
      <StyledScrollWrapper>
        <ModalBody overflowY='auto' mt='8' mb='10' px='10'>
          <RegisterSchoolForm />
        </ModalBody>
      </StyledScrollWrapper>
    </ModalContent>
  );
};
